<form
  [formGroup]='formGroup'
  class='widget'
>
  <div class='form-group'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>

    <div class='input-group'>
      <div
        [class.is-invalid]='formGroup.invalid && formGroup.touched'
        [class.ng-dirty]=formGroup.dirty
        [class.ng-invalid]='formGroup.invalid && formGroup.touched'
        [class.ng-touched]=formGroup.touched
        [class.ng-valid]=formGroup.valid
        class='form-control form-control-sm ng-select-single-control'
      >
        <ng-select
          [bindLabel]='options?.bindLabel'
          [bindValue]='options?.bindValue'
          [id]='inputId'
          [items]='options?.items'
          [notFoundText]='notFoundText'
          [placeholder]='placeholder'
          [readonly]='disabled'
          appendTo='body'
          formControlName='value'>
          <ng-template ng-footer-tmp>
            <div class='input-filtered-select-footer'>
              <span (click)='actionClick.emit()'
                    class='btn btn-link btn-sm'>{{ options?.footerAction?.label | async }}</span>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <small
      [innerHTML]='help'
      class='form-text text-muted' id='ptWFilteredSelectHelp_{{controlName}}'
    ></small>
  </div>
</form>
